import {apiUrl} from '../../config/net'
import api from '../../tools/api-tools'

/**
 * 邀请有礼部分页面
 */
export default class Invite {
  /**
   * 获取用户的绑定状态
   */
  getUserBindStatus () {
    return api.get(`${apiUrl}/v1/mobile/recommand/check-shengyihelper-bind`).then(res => {
      return res.data
    })
  }

  /**
   * 绑定账号
   * @param code
   */
  bindAccount (code) {
    return api.get(`http://shengyi-helper.laoban100.com/AccountBindHandle/index?code=${code}`).then(res => {
      console.log('绑定账号API')
      console.log(res)
      return res.data
    })
  }

  /**
   * 获取邀请奖励列表
   */
  getMoneyList () {
    return api.get(`${apiUrl}/v1/mobile/recommand/info`).then(res => {
      return res.data
    })
  }

  /**
   * 获取分享信息
   */
  getShareInfo () {
    return api.get(`${apiUrl}/v1/mobile/recommand/share/info`).then(res => {
      return res.data
    })
  }
}



// WEBPACK FOOTER //
// ./src/model/invite/index.js